import React from 'react'
import Chart from 'chart.js' 

const ChurnChart = ({dataForChurnGraph}) => {

    let enrollmentChartMMA = React.createRef()
    let enrollmentChartLSMA = React.createRef()
    let enrollmentChartTMA = React.createRef()
    let enrollmentChartMOR = React.createRef()

    let churnChartMMA = React.createRef()
    let churnChartLSMA = React.createRef()
    let churnChartTMA = React.createRef()
    let churnChartMOR = React.createRef()

    React.useEffect(() => {
        const MyChartMMARef = enrollmentChartMMA.current.getContext("2d");
        const MyChartLSMARef = enrollmentChartLSMA.current.getContext("2d");
        const MyChartTMARef = enrollmentChartTMA.current.getContext("2d");
        const MyChartMORRef = enrollmentChartMOR.current.getContext("2d");

        const MyChurnChartMMARef = churnChartMMA.current.getContext("2d");
        const MyChurnChartLSMARef = churnChartLSMA.current.getContext("2d");
        const MyChurnChartTMARef = churnChartTMA.current.getContext("2d");
        const MyChurnChartMORRef = churnChartMOR.current.getContext("2d");

        if(dataForChurnGraph['mma']) {
            if(dataForChurnGraph['mma'].label) {
                new Chart(MyChartMMARef, {
                    type: 'line',
                    data: {
                        labels: dataForChurnGraph['mma'].label.reverse(),
                        datasets: [
                            {
                                label: 'Enrollment', 
                                data: dataForChurnGraph['mma'].enrollment.reverse(),
                                backgroundColor: 'rgba(0, 140, 255, 0.5)'
                            },
                            {
                                label: 'Lost',
                                data: dataForChurnGraph['mma'].studentsLost.reverse(),
                                backgroundColor: 'rgba(255, 0, 0, 0.5)'
                            },
                            {
                                label: 'Gained',
                                data: dataForChurnGraph['mma'].studentsGained.reverse(),
                                backgroundColor: 'rgba(100, 100, 0, 0.5)'
                            }
                        ]
        
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {  
                                  beginAtZero: true,
                                  
                                  stepSize: 1,
                                }
                              }] 
                        }
                    }
                })
                new Chart(MyChurnChartMMARef, {
                    type: 'line',
                    data: {
                        labels: dataForChurnGraph['mma'].label,
                        datasets: [
                            {
                                label: 'Churn %',
                                data: dataForChurnGraph['mma'].churn.reverse(),
                                backgroundColor: 'rgba(208, 105, 0, 0.5)'
                            }
                        ]
        
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {  
                                  beginAtZero: true,
                                  
                                  stepSize: 1,
                                }
                              }] 
                        }
                    }
                })
                new Chart(MyChartLSMARef, {
                    type: 'line',
                    data: {
                        labels: dataForChurnGraph['lsma'].label.reverse(),
                        datasets: [
                            {
                                label: 'Enrollment', 
                                data: dataForChurnGraph['lsma'].enrollment.reverse(),
                                backgroundColor: 'rgba(0, 140, 255, 0.5)'
                            },
                            {
                                label: 'Lost',
                                data: dataForChurnGraph['lsma'].studentsLost.reverse(),
                                backgroundColor: 'rgba(255, 0, 0, 0.5)'
                            },
                            {
                                label: 'Gained',
                                data: dataForChurnGraph['lsma'].studentsGained.reverse(),
                                backgroundColor: 'rgba(100, 100, 0, 0.5)'
                            }
                        ]
        
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {  
                                  beginAtZero: true,
                                  
                                  stepSize: 1,
                                }
                              }] 
                        }
                    }
                })
                new Chart(MyChurnChartLSMARef, {
                    type: 'line',
                    data: {
                        labels: dataForChurnGraph['lsma'].label,
                        datasets: [
                            {
                                label: 'Churn %',
                                data: dataForChurnGraph['lsma'].churn.reverse(),
                                backgroundColor: 'rgba(208, 105, 0, 0.5)'
                            }
                        ]
        
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {  
                                  beginAtZero: true,
                                  
                                  stepSize: 1,
                                }
                              }] 
                        }
                    }
                })
                new Chart(MyChartTMARef, {
                    type: 'line',
                    data: {
                        labels: dataForChurnGraph['tma'].label.reverse(),
                        datasets: [
                            {
                                label: 'Enrollment', 
                                data: dataForChurnGraph['tma'].enrollment.reverse(),
                                backgroundColor: 'rgba(0, 140, 255, 0.5)'
                            },
                            {
                                label: 'Lost',
                                data: dataForChurnGraph['tma'].studentsLost.reverse(),
                                backgroundColor: 'rgba(255, 0, 0, 0.5)'
                            },
                            {
                                label: 'Gained',
                                data: dataForChurnGraph['tma'].studentsGained.reverse(),
                                backgroundColor: 'rgba(100, 100, 0, 0.5)'
                            }
                        ]
        
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {  
                                  beginAtZero: true,
                                  
                                  stepSize: 1,
                                }
                              }] 
                        }
                    }
                })
                new Chart(MyChurnChartTMARef, {
                    type: 'line',
                    data: {
                        labels: dataForChurnGraph['tma'].label,
                        datasets: [
                            {
                                label: 'Churn %',
                                data: dataForChurnGraph['tma'].churn.reverse(),
                                backgroundColor: 'rgba(208, 105, 0, 0.5)'
                            }
                        ]
        
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {  
                                  beginAtZero: true,
                                  
                                  stepSize: 1,
                                }
                              }] 
                        }
                    }
                })
                new Chart(MyChartMORRef, {
                    type: 'line',
                    data: {
                        labels: dataForChurnGraph['mor'].label.reverse(),
                        datasets: [
                            {
                                label: 'Enrollment', 
                                data: dataForChurnGraph['mor'].enrollment.reverse(),
                                backgroundColor: 'rgba(0, 140, 255, 0.5)'
                            },
                            {
                                label: 'Lost',
                                data: dataForChurnGraph['mor'].studentsLost.reverse(),
                                backgroundColor: 'rgba(255, 0, 0, 0.5)'
                            },
                            {
                                label: 'Gained',
                                data: dataForChurnGraph['mor'].studentsGained.reverse(),
                                backgroundColor: 'rgba(100, 100, 0, 0.5)'
                            }
                        ]
        
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {  
                                  beginAtZero: true,
                                  
                                  stepSize: 1,
                                }
                              }] 
                        }
                    }
                })
                new Chart(MyChurnChartMORRef, {
                    type: 'line',
                    data: {
                        labels: dataForChurnGraph['mor'].label,
                        datasets: [
                            {
                                label: 'Churn %',
                                data: dataForChurnGraph['mor'].churn.reverse(),
                                backgroundColor: 'rgba(208, 105, 0, 0.5)'
                            }
                        ]
        
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {  
                                  beginAtZero: true,
                                  
                                  stepSize: 1,
                                }
                              }] 
                        }
                    }
                })
            }
        }

    }, [dataForChurnGraph])

    return (
        <div>
            <div className='school-data-database__chart'>
                <div>Mountainside</div>
                <div className='school-data-database__each-chart-wrapper'>
                    <canvas id="MYCHURNCHART-MMA" ref={enrollmentChartMMA}/>
                </div>
                <div className='school-data-database__each-chart-wrapper'>
                    <canvas id="MYCHURNCHART-MMA" ref={churnChartMMA}/>
                </div>
            </div>
            <div className='school-data-database__chart'>
                <div>Lakeside</div>
                <div className='school-data-database__each-chart-wrapper'>
                    <canvas id="MYCHURNCHART-LSMA" ref={enrollmentChartLSMA}/>
                </div>
                <div className='school-data-database__each-chart-wrapper'>
                    <canvas id="MYCHURNCHART-LSMA" ref={churnChartLSMA}/>
                </div>
            </div>
            <div className='school-data-database__chart'>
                <div>Treeside</div>
                <div className='school-data-database__each-chart-wrapper'>
                    <canvas id="MYCHURNCHART-TMA" ref={enrollmentChartTMA}/>
                </div>
                <div className='school-data-database__each-chart-wrapper'>
                    <canvas id="MYCHURNCHART-TMA" ref={churnChartTMA}/>
                </div>
            </div>
            <div className='school-data-database__chart'>
                <div>Morningside</div>
                <div className='school-data-database__each-chart-wrapper'>
                    <canvas id="MYCHURNCHART-MOR" ref={enrollmentChartMOR}/>
                </div>
                <div className='school-data-database__each-chart-wrapper'>
                    <canvas id="MYCHURNCHART-MOR" ref={churnChartMOR}/>
                </div>
            </div>
        </div>
    )
}
export default ChurnChart;